import { tss } from "tss-react";
import { panelHeaderColor, boxShadow } from "./common";

const useStyles = tss.create({
    root: {
        position: "absolute",
        top: 46,
        left: 300,
        zIndex: 10,
        width: 300,
        height: "100%",
    },
    layerTitle: {
        display: "inline-flex",
        position: "relative",
        left: 12,
        width: 190,
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        alignItems: "center",
        color: "#002776",
        fontSize: 14,
        letterSpacing: "0.1px",
        lineHeight: "16px",
        boxShadow: boxShadow,
        backgroundColor: panelHeaderColor,
    },
    button: {
        width: 16,
        height: 16,
        minWidth: 16,
        margin: "8px 4px 0 8px",
        position: "absolute",
        right: 6,
    },
    layerContainer: {
        display: "flex",
        height: 46,
        width: "100%",
    },
    toolIcon: {
        width: 24,
        height: 24,
        marginTop: 5,
    },
    topIcon: {
        color: "rgb(170,170,170)",
    },
    toolbar: {
        //display: "flex",
        display: "none",
        justifyContent: "space-around",
        height: 37,
        //backgroundColor: backgroundColor,
    },
    layerInput: {
        width: 50,
    },
    numberInput: {
        width: 45,
        color: "black",
        textAlign: "right",
        fontSize: 14,
        marginTop: 0,
        paddingRight: '8px'
    },
    content: {
        maxHeight: "calc(100vh - 132px)",
        overflow: "auto",
    },
    grey: {
        minWidth: 16,
        color: "#AAAAAA",
    },
    borderNone: {
        border: "none",
        minWidth: 16,
        width: 52,
    },
    layerOpacityInput: {
        "& input": {
            fontSize: 14,
            letterSpacing: "0px",
            lineHeight: "16px",
            height: 15,
            width: 50,
            outline: 0,
            borderBottom: "solid 1px #adbbd3",
            textAlign: "center",
        },
    },
});
export default useStyles;
